var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#shield_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M20 24.167v-10m-5 5h10m8.333.833c0 8.18-8.924 14.13-12.17 16.025-.37.215-.554.323-.814.379a1.9 1.9 0 0 1-.7 0c-.26-.056-.444-.164-.813-.38C15.589 34.132 6.666 28.182 6.666 20v-7.97c0-1.333 0-2 .218-2.572.192-.506.505-.957.911-1.315.46-.405 1.084-.64 2.332-1.107l8.936-3.351c.347-.13.52-.195.698-.221q.239-.034.477 0c.178.026.351.09.698.22l8.936 3.352c1.248.468 1.872.702 2.331 1.107.406.358.72.809.912 1.315.218.573.218 1.239.218 2.571z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__a",
    x1: 30.967,
    x2: -24.798,
    y1: 4.358,
    y2: 21.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgShield;